import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import profileIcon from '../images/profileIcon.svg';
import SearchButton from './SearchButton';

function Header({ Title }) {
  const history = useHistory();

  return (
    <div className="header">
      <button
        className="header-btn"
        type="button"
        onClick={ () => history.push('/profile') }
      >
        <img
          className="header-img"
          src={ profileIcon }
          data-testid="profile-top-btn"
          alt="Profile"
        />

      </button>
      <h1 className="header-title" data-testid="page-title">{Title}</h1>
      <SearchButton />
    </div>
  );
}

Header.propTypes = {
  Title: PropTypes.string.isRequired,
};

export default Header;
